module.exports = __webpack_public_path__ + "img/section_r.74b03577.png";